import { base64toZip } from "@domains/utils/fileMethods";
import * as moment from "moment";
class ContractStatement {
    constructor(action, usecase) {
        this.action = action;
        this.usecase = usecase;
        this.emailList = [];
    }
    getContractStatement(req) {
        this.action.contract.hideError("Contract");
        this.action.contract.loader("Contract");
        this.usecase.contract.execute({
            onSuccess: (data) => {
                this.action.contract.clear("Contract");
                this.action.contract.getContractReport(data, "Contract");
                this.action.contract.stopLoader("Contract");
            },
            onError: (error) => {
                this.action.contract.setError({ error: error, isOpen: true }, "Contract");
                this.action.contract.stopLoader("Contract");
            },
        }, req);
    }
    getContractCommodity(req) {
        this.action.contractCommodityDetails.loader("ContractCommodity");
        this.action.contractCommodityDetails.hideError("ContractCommodity");
        this.action.contractCommodityDetails.clear("ContractCommodity");
        this.usecase.contractCommodity.execute({
            onSuccess: (data) => {
                this.action.contractCommodityDetails.clear("ContractCommodity");
                this.action.contractCommodityDetails.getContractCommodity(data, "ContractCommodity");
                this.action.contractCommodityDetails.stopLoader("ContractCommodity");
            },
            onError: (error) => {
                this.action.contractCommodityDetails.setError({
                    error: error,
                    isOpen: true,
                }, "ContractCommodity");
                this.action.contractCommodityDetails.stopLoader("ContractCommodity");
            },
        }, req);
    }
    downloadContractPDF(req) {
        return new Promise((resolve, reject) => {
            this.usecase.contractPDF.execute({
                onSuccess: (resp) => {
                    base64toZip(resp.data, "Contract_Download" + moment().format("DD-MM-YY"));
                    resolve(resp.status);
                },
                onError: (error) => {
                    reject(false);
                },
            }, req);
        });
    }
    sendEmailContractPDF(req) {
        this.emailList = req.emailIds;
        return new Promise((resolve, reject) => {
            return this.usecase.contractEmail.execute({
                onSuccess: (status) => {
                    resolve(status);
                },
                onError: (error) => {
                    reject(false);
                },
            }, req);
        });
    }
    contractViewPDF(req) {
        return new Promise((resolve, reject) => {
            this.usecase.contractViewPDF.execute({
                onSuccess: (resp) => {
                    if (resp.status)
                        resolve(resp);
                    reject(resp);
                },
                onError: (error) => {
                    reject({
                        status: false,
                        data: "",
                    });
                },
            }, req);
        });
    }
}
export default ContractStatement;
